export default "__VITE_ASSET__y6$osHtJ__"